exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "._3-vi4q5QFXVh122r0sIapD {\n  display: flex;\n  justify-content: flex-end;\n}\n\n._1Lu9EtSUVkpQswaDsF02y9 {\n  margin-right: auto;\n}", "", {"version":3,"sources":["/home/forge/leadpm.io/frontend/src/Modals/Caveat/Components/Footer/Component.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,0BAA0B;CAC3B;;AAED;EACE,mBAAmB;CACpB","file":"Component.css","sourcesContent":[".footer {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.deleteButton {\n  margin-right: auto;\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"footer": "_3-vi4q5QFXVh122r0sIapD",
	"deleteButton": "_1Lu9EtSUVkpQswaDsF02y9"
};